module.exports = __webpack_public_path__ + "static/media/Picture3.81531a39.jpg";